// 앱 호출 함수
const callApp = {
  // 보안 화면 on
  activateSecureScreen(urlPattern) {
    const param = JSON.stringify({
      activateSecureScreen: {
        urlPattern,
      },
    });

    const userAgent = window.navigator.userAgent.toLowerCase();
    try {
      if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        window.webkit.messageHandlers.activateSecureScreen.postMessage(param);
      } else if (userAgent.indexOf('android') > -1) {
        window.androidBridge.receivedJavaScriptMessage(
          'activateSecureScreen',
          param,
        );
      } else {
        // alert('The others');
      }
    } catch (err) {
      alert(err);
    }
  },

  // 보안 화면 off
  inactivateSecureScreen(urlPattern) {
    const param = JSON.stringify({
      inactivateSecureScreen: {
        urlPattern,
      },
    });

    const userAgent = window.navigator.userAgent.toLowerCase();
    try {
      if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        window.webkit.messageHandlers.inactivateSecureScreen.postMessage(param);
      } else if (userAgent.indexOf('android') > -1) {
        window.androidBridge.receivedJavaScriptMessage(
          'inactivateSecureScreen',
          param,
        );
      } else {
        //alert('The others');
      }
    } catch (err) {
      alert(err);
    }
  },

  // 모바일 alert 호출
  mobileAlert(message) {
    const param = JSON.stringify({
      alert: {
        title: 'title',
        message,
      },
    });

    const userAgent = window.navigator.userAgent.toLowerCase();
    try {
      if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        window.webkit.messageHandlers.alert.postMessage(param);
      } else if (userAgent.indexOf('android') > -1) {
        window.androidBridge.receivedJavaScriptMessage('alert', param);
      } else {
        // alert('The others');
      }
    } catch (err) {
      alert(err);
    }
  },

  // 로그인 성공 시
  // authToken, userToken, sessionToken, contextData, callBackFunctionName
  setSessionContext(
    userKey,
    authToken,
    sessionToken,
    contextData,
    callBackFunctionName,
  ) {
    if (!contextData) {
      contextData = {
        userKey,
        authToken,
        sessionToken,
        //useLBSType: [],
        scanningTypes: [],
        locationIndices: {},
      };
    }

    const param = JSON.stringify({
      setSessionContext: {
        mainUrl: process.env.VUE_APP_MAIN_URL,
        returnScript: callBackFunctionName || 'afterSetSessionContext',
        contextData: contextData,
        scanningTypes: contextData.scanningTypes,
        locationIndices: contextData.locationIndices,
      },
    });

    // alert('#mobile setSessionContext 호출전 :: ' + param);
    const userAgent = window.navigator.userAgent.toLowerCase();

    try {
      if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        window.webkit.messageHandlers.setSessionContext.postMessage(param);
      } else if (userAgent.indexOf('android') > -1) {
        window.androidBridge.receivedJavaScriptMessage(
          'setSessionContext',
          param,
        );
      } else {
        // alert('The others');
      }
    } catch (err) {
      alert(err);
    }
  },

  // 로그아웃
  logout() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const param = JSON.stringify({
      logout: {},
    });

    try {
      if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        window.webkit.messageHandlers.logout.postMessage(param);
      } else if (userAgent.indexOf('android') > -1) {
        window.androidBridge.receivedJavaScriptMessage('logout', param);
      } else {
        // alert('The others');
      }
    } catch (err) {
      alert(err);
    }
  },

  // 쿠키 없을 때 앱에 세션 데이터 요청
  validateSession(callbackScriptName) {
    // alert('validateSession - 쿠키 없을 때 앱에 세션 데이터 요청');
    const userAgent = window.navigator.userAgent.toLowerCase();
    const param = JSON.stringify({
      validateSession: {
        returnScript: callbackScriptName || 'afterValidateSession',
      },
    });

    try {
      if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        window.webkit.messageHandlers.validateSession.postMessage(param);
      } else if (userAgent.indexOf('android') > -1) {
        window.androidBridge.receivedJavaScriptMessage(
          'validateSession',
          param,
        );
      } else {
        // alert('The others');
      }
    } catch (err) {
      alert(err);
    }
  },

  // LBS
  invalidateLocation() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const param = JSON.stringify({
      invalidateLocation: {},
    });

    //alert('lbs:' + userAgent);

    try {
      if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        //alert('lbs-if:' + param);
        window.webkit.messageHandlers.invalidateLocation.postMessage(param);
      } else if (userAgent.indexOf('android') > -1) {
        //alert('lbs-else:' + param);
        window.androidBridge.receivedJavaScriptMessage(
          'invalidateLocation',
          param,
        );
      } else {
        // alert('The others');
      }
    } catch (err) {
      alert(err);
    }
  },

  // 파일 다운로드
  downloadFile(fileParam) {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const param = JSON.stringify({
      downloadFile: {
        fileName: fileParam.fileName,
        dataUrl: fileParam.dataUrl,
      },
    });

    try {
      if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        window.webkit.messageHandlers.downloadFile.postMessage(param);
      } else if (userAgent.indexOf('android') > -1) {
        window.androidBridge.receivedJavaScriptMessage('downloadFile', param);
      }
    } catch (err) {
      alert(err);
    }
  },

  // 앱초기접속 - 정책 동의
  agreePolicy() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const param = JSON.stringify({
      agreePolicy: {},
    });

    try {
      if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        window.webkit.messageHandlers.agreePolicy.postMessage(param);
      } else if (userAgent.indexOf('android') > -1) {
        window.androidBridge.receivedJavaScriptMessage('agreePolicy', param);
      }
    } catch (err) {
      alert(err);
    }
  },

  // 모바일 키보드 내리기
  keyboardDown() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const param = JSON.stringify({
      keyboardDown: {},
    });

    try {
      if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1) {
        window.webkit.messageHandlers.keyboardDown.postMessage(param);
      } else if (userAgent.indexOf('android') > -1) {
        window.androidBridge.receivedJavaScriptMessage('keyboardDown', param);
      }
    } catch (err) {
      alert(err);
    }
  },
};

export { callApp };
